import {ButtonHTMLAttributes, DetailedHTMLProps} from "react";
import AppButton, {IButtonAppProps} from "./AppButton";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import {getManager} from "../../../ts/manager/Manager";

interface IProps
{
    routeChoice: RouteChoice;
    onClick?: (routeChoice: RouteChoice) => void;
    scrollToPath?: string;
}

const RouteChoiceButton = (props: IProps & IButtonAppProps & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) =>
{
    let {
        routeChoice,
        scrollToPath,
        label,
        children,
        className,
        ...elementProps
    } = props;

    const href = props.href ?? routeChoice.getHref();
    const activeHref = getManager().navigation.model.href;

    let onRedirectCallback: (() => void)|undefined;
    if(scrollToPath){
        onRedirectCallback = () => {
            if(elementProps.onRedirectCallback){
                elementProps.onRedirectCallback();
            }
            getManager().ui.findRouteViewChoice(scrollToPath);
        }
    } else {
        onRedirectCallback = elementProps.onRedirectCallback;
    }

    let onClick:(() => void)|undefined = props.onClick;
    if(props.onClick){
        onClick = () => {
            if(props.onClick){
                props.onClick(routeChoice);
            }
        }
    }

    className = (className ?? "") + (className && routeChoice.className ? " " : "") + (routeChoice.className ?? "");

    return <AppButton
        {...elementProps}
        href={href}
        selected={href === activeHref}
        label={((label ?? null) === null) && !children ? routeChoice.name : label}
        onClick={onClick}
        onRedirectCallback={onRedirectCallback}
        className={className}
        conditionalClassName={routeChoice.conditionalClassName}
    >
        {children}
    </AppButton>
}

export default RouteChoiceButton;